import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Box from '@mui/material/Box';
import React, { useContext } from 'react';
import { RemediationContext } from '../../../NRRemediation/NRRemediationContext';
import NRRemediationStatusButton from '../../../NRRemediationStatusButton/NRRemediationStatusButton';
import { RemediationDetailsFormatter } from '../RemediationDetailsProvider/RemediationDetailsProvider';
import NRRemediationContent from '../../../NRRemediation/NRRemediationContent/NRRemediationContent';

export function RemediationStatusFormatter({ value, column, row, small }) {
  const { setOpenRemediationModal, setRows, setContent } = useContext(RemediationContext);

  function handleOnClick() {
    setContent(<NRRemediationContent />);
    setRows([row]);
    setOpenRemediationModal(true);
  }
  return (
    <Box display={'flex'}>
      <NRRemediationStatusButton small={small} status={value} handleOnClick={handleOnClick} isInteractive={false} />
      <RemediationDetailsFormatter row={row} />
    </Box>
  );
}

export const RemediationStatusProvider = props => <DataTypeProvider formatterComponent={RemediationStatusFormatter} {...props} />;
